import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Table, Loader} from 'semantic-ui-react';
import {colors} from '../../../../common/constants/colors';
import ChartSection from './chartSection';
import TotalsSalesTable from './table/totals';
import SalesByAgenciesTable from './table';

class SalesByAgencies extends Component {
  getTotals() {
    const {salesByDealer} = this.props;
    return salesByDealer.map((dealerData, index) => {
      return {
        'code': dealerData.dealerRuc, 'name': dealerData.dealerName,
        'amount': parseFloat(dealerData.total.toFixed(2)), 'showData': true,
        'color': colors[index], 'aliasName': dealerData.alias || dealerData.dealerName,
      };
    });
  }
  
  getSalesByDealer(dealerData) {
    const sales = dealerData && dealerData.dealerSales ? dealerData.dealerSales : [];

    return sales.map((dealerData, index) => {
      return {
        'code': dealerData.agencyCode, 'name': dealerData.agencyName,
        'amount': parseFloat(dealerData.total.toFixed(2)), 'showData': true,
        'color': colors[index],
      };
    });
  }

  renderTotalsSection() {
    const {showData, loading} = this.props;
    const totals = this.getTotals();

    if (!showData || loading || !totals.length) {
      return null;
    }
    return (
      <Card raised fluid className='chart-container-sales-by-agency'>
        <Grid textAlign='left'>
          <Grid.Row>
            <Grid.Column width={8}>
              <ChartSection title={'VENTAS TOTALES'} data={totals} type='dealer' />
            </Grid.Column>
            <Grid.Column width={8}>
              <TotalsSalesTable data={totals} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }

  renderSectionByDealer() {
    const {loading, salesByDealer} = this.props;
    if (loading) {
      return (
        <Card raised fluid>
          <Table striped>
            <Table.Body>
              <Table.Row>
                <Table.Cell colSpan='100%'>
                  <Loader active inline='centered' />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Card>
      );
    }

    if (!salesByDealer.length) {
      return (
        <Card raised fluid>
          <h3 className='without-data'>No hay datos disponibles con los filtros seleccionados</h3>
        </Card>
      );
    }

    return salesByDealer.map((dealerData, index) => {
      const salesByAgencies = this.getSalesByDealer(dealerData);
      return (
        <div key={index}>
          <Card raised fluid className='chart-container-sales-by-agency'>
            <ChartSection title={dealerData.dealerName} data={salesByAgencies} type='agency' />
          </Card>
          <SalesByAgenciesTable data={dealerData} />
        </div>
      );
    });
  }

  render() {
    return (
      <div>
        {this.renderTotalsSection()}
        {this.renderSectionByDealer()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.sales.loadingSalesByDealer,
    'salesByDealer': state.sales.salesByDealer,
  };
};

export default connect(mapStateToProps, {
})(SalesByAgencies);
